export enum Stage {
  Dev = 'develop',
  Staging = 'staging',
  Production = 'production'
}
